import FieldConfig from "../../../proto/field-config"

import FieldSelectField from "../select-field/select-field"
import FieldSelectEntityField_Popover from "./components/popover/popover"
import FieldSelectEntityField_FormValueNotEmpty from "./components/form/value-not-empty"
import {GroupedData} from "../../../../data-structures/group"
import {EntityType} from "../../../../gd/const/item";
import FieldsCollection from "../../../collection/base/fields-collection"

export default class FieldSelectEntityField extends FieldSelectField {

    public fieldsCollections    : FieldsCollection[]
    public fieldsStructures     : {[key in EntityType]?: GroupedData}

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                      = "Select entity field"

        this.fieldsCollections              = _.get(config, 'fieldsCollections', [])
        this.fieldsStructures               = _.get(config, 'fieldsStructures', {})

        this.components.PopoverMenu         = FieldSelectEntityField_Popover
        this.components.FormValueNotEmpty   = FieldSelectEntityField_FormValueNotEmpty
    }
}